// swiperjs sliders
import './js/front-swiper';


// modal video
import "modal-video/css/modal-video.min.css";
import ModalVideo from "modal-video";


(function ($) {
  // set modals
  new ModalVideo(".video-modal-youtube", {
    channel: "youtube",
    youtube: {
      rel: 0,
    },
  });
  new ModalVideo(".video-modal-vimeo", { channel: "vimeo" });
})(jQuery);